






























































import BtnDefault from '@/components/UI/BtnDefault.vue';
import {Component, Vue, Watch} from 'vue-property-decorator';
import DialogFooter from '@/components/UI/DialogFooter.vue';
import {namespace} from 'vuex-class';
import draggable from 'vuedraggable'

const dialog = namespace('dialog')
const forms = namespace('forms')
const surveys = namespace('surveys')

@Component({
  components: {
    BtnDefault,
    DialogFooter,
    draggable,
  },
  name: "AddAnswersForm"
})
export default class AddAnswersForm extends Vue {

  @dialog.Getter('fullDialogShow') protected fullDialogShow: any
  @dialog.Mutation('SetFullDialogShow') protected SetFullDialogShow: any
  @forms.Getter('options') protected options:any
  @surveys.Getter('survey') protected survey:any

  answer:any = {
    value: '',
    includeQuestions: [],
    type: 'regular'
  }

  addAnswer() {
    this.options.answers.push({...this.answer});
    this.answer.value = ''
  }

  save() {
    this.options.answers.forEach((answer:any, index:number) => {
      answer.order = index
    })
    this.SetFullDialogShow(false)
  }


}
